import { RemoteDoctorsRegister } from '../../../data/usecases/doctors/remote-doctorsRegister'
import { RemoteDoctors } from '../../../data/usecases/doctors/remote-doctors'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeDoctorsRegister = (step: string) => new RemoteDoctorsRegister(
  `/public/register/doctor/${step}`,
  makeAxiosHttpClient(),
)

export const makePlanRegister = (step: string) => new RemoteDoctorsRegister(`/public/register/${step}`, makeAxiosHttpClient())

export const makeDoctorsEdit = () => new RemoteDoctorsRegister('/doctor/update-doctor', makeAxiosHttpClient())

export const makeDoctorsTerms = () => new RemoteDoctorsRegister(
  '/public/register/accept-terms/doctor',
  makeAxiosHttpClient(),
)

export const makeDoctors = () => new RemoteDoctors('/users/me/doctor', makeAxiosHttpClient())

export const makeDoctor = () => new RemoteDoctors('/doctor', makeAxiosHttpClient())
